import { stepsFullPath } from "../stepsPath";
import { TherapistFields } from "../util";

export const coveredFields: TherapistFields = [
  "how_long_practicing",
  "about_qualifications",
];
export const step3_2Path = "/3_2";
export const step3_2FullPath = `${stepsFullPath}${step3_2Path}`;
